import { endpointSelectorPlugin } from "./endpoint-selector";

export const plugins = [endpointSelectorPlugin];
